import { render, staticRenderFns } from "./PaymentAccountComponent.vue?vue&type=template&id=d971ba12&"
import script from "./PaymentAccountComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports